import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import hadarImage from '../../../Assets/Image/Attraction/historical/Allhistory/hadar3.jpg';
import asaitaImage from '../../../Assets/Image/Attraction/historical/Allhistory/Ali Mirah.jpg';
import dallolImage from '../../../Assets/Image/Attraction/historical/Allhistory/saltTrade.jpg';
import triangleImage from '../../../Assets/Image/Attraction/historical/Allhistory/afartriangle.jpg';
import awashImage from '../../../Assets/Image/Attraction/historical/Allhistory/awashVally.jpg';
import abbeImage from '../../../Assets/Image/Attraction/historical/Allhistory/saltTrade.jpg';
import zulaImage from '../../../Assets/Image/Attraction/historical/Allhistory/gulf of zula.jpg';
import ertaAleImage from '../../../Assets/Image/Attraction/historical/Allhistory/ertaAlle.jpg';
import yangudiImage from '../../../Assets/Image/Attraction/historical/Allhistory/yangudipark.jpg';
const Historical = () => {
  const [selectedAttraction, setSelectedAttraction] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [imageLoaded, setImageLoaded] = useState({});
  const attractions = [
    { id: 1, title: 'Hadar Archaeological Site', description: 'Known worldwide as the cradle of humanity...', image: hadarImage, position: 'left' },
    { id: 2, title: 'Asaita Sultanate', description: 'The Sultanate of Asaita, also known as the Aussa Sultanate...', image: asaitaImage, position: 'right' },
    { id: 3, title: 'Dallol Salt Trade Heritage', description: 'Dallol is not only known for its surreal landscapes...', image: dallolImage, position: 'left' },
    { id: 4, title: 'Afar Triangle', description: 'Located in northeastern Ethiopia...', image: triangleImage, position: 'right' },
    { id: 5, title: 'Awash Valley Sites', description: 'The Awash Valley houses several significant archaeological sites...', image: awashImage, position: 'left' },
    { id: 6, title: 'Lake Abbe', description: 'Lake Abbe holds both scenic beauty and cultural significance...', image: abbeImage, position: 'right' },
    { id: 7, title: 'Gulf of Zula', description: 'The Gulf of Zula, or Annesley Bay, was home to the ancient port of Adulis...', image: zulaImage, position: 'left' },
    { id: 8, title: 'Erta Ale Volcano', description: 'The Erta Ale Volcano region holds deep cultural significance...', image: ertaAleImage, position: 'right' },
    { id: 9, title: 'Yangudi-Rassa National Park', description: 'Beyond its wildlife significance, Yangudi-Rassa National Park embodies...', image: yangudiImage, position: 'left' }
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <StyledHistoricalPage>
      <ParallaxHero>
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <h1>Historical Wonders of Afar</h1>
          <div className="accent-lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p>Discover the ancient heritage and cultural richness of the Afar region</p>
          {/* <motion.div 
            className="scroll-indicator"
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          >
            <span>Scroll to Explore</span>
            <i className="arrow-down"></i>
          </motion.div> */}
        </motion.div>
      </ParallaxHero>

      <Container fluid>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <AttractionsGrid>
            {attractions.map((attraction, index) => (
              <motion.div
                key={attraction.id}
                variants={fadeInUp}
                className={`attraction-card ${index % 2 === 0 ? 'left' : 'right'}`}
                onHoverStart={() => setHoveredId(attraction.id)}
                onHoverEnd={() => setHoveredId(null)}
                onClick={() => setSelectedAttraction(attraction)}
              >
               <div className={`image-wrapper ${!imageLoaded[attraction.id] ? 'loading' : ''}`}>
  <img
    src={attraction.image}
    alt={attraction.title}
    onLoad={() => setImageLoaded(prev => ({...prev, [attraction.id]: true}))}
    loading="lazy"
  />
  <div className="image-overlay">
    <button className="explore-btn">
      Explore More
    </button>
  </div>
</div>
                <motion.div 
                  className="content"
                  animate={{
                    y: hoveredId === attraction.id ? -10 : 0
                  }}
                >
                  <h2>{attraction.title}</h2>
                  <p>{attraction.description}</p>
                  <div className="details">
                    <motion.span
                      className="location-tag"
                      whileHover={{ scale: 1.1 }}
                    >
                      <i className="location-icon"></i>
                      Afar Region
                    </motion.span>
                    <motion.span
                      className="category-tag"
                      whileHover={{ scale: 1.1 }}
                    >
                      Historical Site
                    </motion.span>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </AttractionsGrid>
        </motion.div>
      </Container>

      <AnimatePresence>
        {selectedAttraction && (
          <DetailModal
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => setSelectedAttraction(null)}
          >
            <motion.div 
              className="modal-content"
              onClick={e => e.stopPropagation()}
              layoutId={`attraction-${selectedAttraction.id}`}
            >
              <img src={selectedAttraction.image} alt={selectedAttraction.title} />
              <div className="modal-info">
                <h2>{selectedAttraction.title}</h2>
                <p>{selectedAttraction.description}</p>
                <div className="modal-actions">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    View Gallery
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="secondary"
                  >
                    Learn More
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </DetailModal>
        )}
      </AnimatePresence>
    </StyledHistoricalPage>
  );
};

const StyledHistoricalPage = styled.div`
  background: #f8f9fa;
  overflow-x: hidden;
`;

const ParallaxHero = styled.div`
  height: 100vh;
  background: linear-gradient(
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.3)
  ), url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;

  .hero-content {
    max-width: 900px;
    padding: 2rem;

    h1 {
      font-size: 5rem;
      font-weight: 800;
      margin-bottom: 2rem;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }

    .accent-lines {
      display: flex;
      gap: 0.5rem;
      justify-content: center;
      margin: 1.5rem 0;

      span {
        height: 4px;
        width: 60px;
        background: white;
        border-radius: 2px;

        &:nth-child(2) {
          width: 40px;
        }
      }
    }

    p {
      font-size: 1.4rem;
      opacity: 0.9;
      margin-bottom: 3rem;
    }

    .scroll-indicator {
      position: absolute;
      bottom: 2rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      
      span {
        font-size: 0.9rem;
        text-transform: uppercase;
        letter-spacing: 2px;
      }

      .arrow-down {
        width: 20px;
        height: 20px;
        border-right: 2px solid white;
        border-bottom: 2px solid white;
        transform: rotate(45deg);
      }
    }
  }
`;

const AttractionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 4rem 2rem;

  .attraction-card {
    background: white;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;

    .image-wrapper {
      position: relative;
      padding-top: 66.67%; /* 3:2 aspect ratio */
      width: 100%;
      overflow: hidden;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: transform 0.6s cubic-bezier(0.33, 1, 0.68, 1);
        will-change: transform;
      }

      &:hover img {
        transform: scale(1.05);
      }

      .image-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0.4)
        );
        opacity: 0;
        transition: opacity 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(2px);

        .explore-btn {
          padding: 1rem 2rem;
          background: rgba(255, 255, 255, 0.95);
          border: none;
          border-radius: 30px;
          font-weight: 600;
          color: #2d7ba8;
          cursor: pointer;
          transform: translateY(20px);
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          
          &:hover {
            background: white;
            transform: translateY(18px) scale(1.02);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          }
        }
      }

      &:hover .image-overlay {
        opacity: 1;
      }
    }
.content {
      padding: 2rem;

      h2 {
        font-size: 1.8rem;
        color: #1e293b;
        margin-bottom: 1rem;
      }

      p {
        color: #64748b;
        line-height: 1.6;
        margin-bottom: 1.5rem;
      }

      .details {
        display: flex;
        gap: 1rem;

        span {
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;

          &.location-tag {
            background: #e0f2fe;
            color: #0369a1;
          }

          &.category-tag {
            background: #f1f5f9;
            color: #475569;
          }
        }
      }
    }
  }
    /* Loading state animation */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
      );
      animation: loading 1.5s infinite;
      display: none;
    }

    &.loading::before {
      display: block;
    }
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const DetailModal = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;

  .modal-content {
    background: white;
    border-radius: 20px;
    overflow: hidden;
    max-width: 900px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .modal-info {
      padding: 3rem;

      h2 {
        font-size: 2.5rem;
        margin-bottom: 1.5rem;
      }

      p {
        margin-bottom: 2rem;
        line-height: 1.8;
      }

      .modal-actions {
        display: flex;
        gap: 1rem;

        button {
          padding: 1rem 2rem;
          border: none;
          border-radius: 30px;
          font-weight: 600;
          cursor: pointer;

          &:first-child {
            background: #2d7ba8;
            color: white;
          }

          &.secondary {
            background: #f1f5f9;
            color: #1e293b;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-content {
      grid-template-columns: 1fr;
    }
  }
`;

export default Historical;